import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Key } from "lucide-react";
import type { TFunction } from "i18next";

interface ResetPasswordDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedAgent: { name: string; email: string } | null;
  onConfirm: (email: string) => void;
  t: TFunction<"translation", undefined>;
}

const ResetPasswordDialog: React.FC<ResetPasswordDialogProps> = ({
  open,
  onOpenChange,
  selectedAgent,
  onConfirm,
  t,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Key className="w-5 h-5 text-[#105BDB]" />
            {t("confirm_password_reset")}
          </DialogTitle>
          <DialogDescription>
            {selectedAgent && t("confirm_password_reset_description", {
              name: selectedAgent.name,
              email: selectedAgent.email,
            })}
          </DialogDescription>
        </DialogHeader>

        {selectedAgent && (
          <div className="py-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-700">
                  {t("name")}:
                </span>
                <span className="text-sm text-gray-900">
                  {selectedAgent.name}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-700">
                  {t("email")}:
                </span>
                <span className="text-sm text-gray-900">
                  {selectedAgent.email}
                </span>
              </div>
            </div>
            <p className="text-xs text-muted-foreground mt-3">
              {t("password_reset_email_will_be_sent")}
            </p>
          </div>
        )}

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={() => selectedAgent && onConfirm(selectedAgent.email)}
            className="bg-[#105BDB] text-white hover:bg-[#0055C4]"
          >
            {t("confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ResetPasswordDialog;
